import TrustBar from "../../components/feature/TrustBar";
import SectionPageHero from "../../components/feature/SectionPageHero";
import ProcessSection from "../home/components/ProcessSection";
import WhyChooseUs from "../home/components/WhyChooseUs";
import ServiceAreasSection from "../home/components/ServiceAreasSection";
import TestimonialsSection from "../home/components/TestimonialsSection";
import FinalCTASection from "../home/components/FinalCTASection";
import { Link } from "react-router-dom";
import { mainServices } from "../../mocks/services";
import { useState } from "react";

const SERVICES_FAQS = [
  { id: 1, q: "What plumbing services does Jerry's offer?", a: "Jerry's provides comprehensive plumbing services including slab leak detection, drain cleaning, water heater repair and replacement, gas line repairs, pipe replacements, fixture installation, garbage disposal service, plumbing remodels, and 24/7 emergency plumbing throughout DFW." },
  { id: 2, q: "Do you offer commercial plumbing and grease trap services?", a: "Yes — Jerry's is a recognized leader in commercial plumbing across DFW, including grease trap installation, sizing, permitting, and maintenance for restaurants and commercial kitchens. We also handle full commercial plumbing builds and repairs for any business type." },
  { id: 3, q: "What welding services are available?", a: "Jerry's offers custom and general welding for aluminum, brass, cast iron, copper, stainless steel, and structural steel. We handle residential, commercial, and industrial welding projects at competitive prices with professional quality workmanship." },
  { id: 4, q: "How quickly can you respond to a plumbing service call?", a: "Most service requests are fulfilled same-day. Emergency calls are prioritized and we dispatch a technician as quickly as possible — often within the hour for urgent situations in Cedar Hill, Fort Worth, Dallas, Arlington, and surrounding DFW cities." },
  { id: 5, q: "Do you offer water heater installation and replacement?", a: "Absolutely. Jerry's installs and replaces all types of water heaters including standard tank water heaters and tankless/on-demand systems. We carry quality brands and provide same-day installation in most cases throughout the DFW metroplex." },
  { id: 6, q: "Are your plumbing services guaranteed?", a: "Yes — we stand behind every repair and installation we perform. Our workmanship is guaranteed, and all work is done to Texas plumbing code by licensed professionals. If there's an issue with our work, we make it right." },
];

export default function ServicesPage() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <main className="pt-[100px]">
      {/* 1. Hero */}
      <SectionPageHero
        badge="Full-Service DFW Plumbing & Heating"
        headline={<>Complete Plumbing, Heating &amp; <span className="text-[#E8500A]">Welding Solutions</span></>}
        subheadline="Residential and commercial plumbing, heating, drain, water heater, grease trap, and welding services delivered by a licensed Master Plumber team across the entire DFW metroplex."
        imageUrl="https://public.readdy.ai/ai/img_res/2cb49eebdfdfbca0436d983e08702df8.jpg"
        stats={[{ value: "4", label: "Core Services" }, { value: "24/7", label: "Emergency" }, { value: "35+", label: "Years DFW" }]}
      />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. All Services Breakdown (Adapted Content) */}
      <section className="bg-[#F8F7F4] py-24 lg:py-32" id="services">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-14">
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">What We Offer</p>
            <h2 className="text-4xl lg:text-5xl font-black text-gray-900" style={{ fontFamily: "'Barlow', sans-serif" }}>Our Complete Service Menu</h2>
          </div>
          <div className="space-y-8">
            {mainServices.map((service, idx) => (
              <div key={service.id} id={service.id} className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
                <div className={`grid lg:grid-cols-2 gap-0 ${idx % 2 !== 0 ? "lg:grid-flow-col-dense" : ""}`}>
                  <div className={`bg-[#F8F7F4] p-10 flex flex-col items-center justify-center ${idx % 2 !== 0 ? "lg:col-start-2" : ""}`}>
                    <div className="w-20 h-20 flex items-center justify-center bg-white rounded-2xl mb-5">
                      <img src={service.icon} alt={service.iconAlt} className="w-14 h-14 object-contain" />
                    </div>
                    <h2 className="text-2xl font-black text-gray-900 text-center" style={{ fontFamily: "'Barlow', sans-serif" }}>{service.title}</h2>
                  </div>
                  <div className={`p-10 ${idx % 2 !== 0 ? "lg:col-start-1 lg:row-start-1" : ""}`}>
                    <p className="text-gray-600 leading-relaxed mb-5">{service.description}</p>
                    <h3 className="font-black text-gray-900 text-sm mb-4" style={{ fontFamily: "'Barlow', sans-serif" }}>Services Include:</h3>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-6">
                      {service.items.map((item) => (
                        <li key={item} className="flex items-center gap-2 text-gray-600 text-sm">
                          <i className="ri-checkbox-circle-fill text-[#E8500A] flex-shrink-0 text-xs" />{item}
                        </li>
                      ))}
                    </ul>
                    <div className="flex flex-wrap gap-3">
                      <a href="tel:8178324968" className="flex items-center gap-2 bg-[#E8500A] hover:bg-[#d14508] text-white font-bold px-5 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap">
                        <i className="ri-phone-fill" /> Call Now
                      </a>
                      <Link to="/contact" className="flex items-center gap-2 border border-gray-200 hover:border-[#E8500A] text-gray-700 hover:text-[#E8500A] font-semibold px-5 py-2.5 rounded-lg text-sm transition-colors whitespace-nowrap">
                        Get Estimate
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. AI Answer Block */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8">
            <div className="bg-[#F8F7F4] rounded-2xl p-8 border-l-4 border-[#E8500A]">
              <h2 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>What Services Are Offered?</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">Jerry's provides comprehensive plumbing, heating, welding, water heater, grease trap, and emergency services for residential and commercial properties across the DFW metroplex. From routine maintenance to full system installations — we handle it all with licensed expertise.</p>
              <ul className="space-y-2">
                {["Plumbing repairs, replacements & remodels", "Water heater repair & installation", "Grease trap installation & commercial plumbing", "Custom and structural welding services"].map((b) => (
                  <li key={b} className="flex items-start gap-2 text-gray-600 text-sm"><i className="ri-check-line text-[#E8500A] flex-shrink-0 mt-0.5" />{b}</li>
                ))}
              </ul>
            </div>
            <div className="bg-[#F8F7F4] rounded-2xl p-8 border-l-4 border-gray-200">
              <h2 className="font-black text-2xl text-gray-900 mb-3" style={{ fontFamily: "'Barlow', sans-serif" }}>Why Professional Plumbing Matters</h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">Professional plumbing ensures proper installation, code compliance, and long-term reliability. DIY plumbing mistakes lead to water damage, mold, gas hazards, and costly structural repairs. A licensed Master Plumber gets it right the first time — protecting your property and investment.</p>
              <ul className="space-y-2">
                {["All work done to Texas plumbing code", "Licensed, insured, and background-checked", "Quality parts and proven techniques", "Work guaranteed — we stand behind it"].map((b) => (
                  <li key={b} className="flex items-start gap-2 text-gray-600 text-sm"><i className="ri-check-line text-[#E8500A] flex-shrink-0 mt-0.5" />{b}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas */}
      <ServiceAreasSection />

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. FAQ */}
      <section className="bg-[#F8F7F4] py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-[#E8500A] font-bold text-xs tracking-widest uppercase mb-3">Services FAQ</p>
            <h2 className="text-4xl font-black text-gray-900" style={{ fontFamily: "'Barlow', sans-serif" }}>Questions About Our Services</h2>
          </div>
          <dl className="space-y-3">
            {SERVICES_FAQS.map((faq) => (
              <div key={faq.id} className={`rounded-xl border overflow-hidden transition-all ${openId === faq.id ? "border-[#E8500A]/30 bg-orange-50/60" : "border-gray-200 bg-white hover:border-orange-200"}`}>
                <dt>
                  <button className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer" onClick={() => setOpenId(openId === faq.id ? null : faq.id)}>
                    <span className={`font-bold text-sm pr-4 leading-snug ${openId === faq.id ? "text-[#E8500A]" : "text-gray-900"}`}>{faq.q}</span>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${openId === faq.id ? "bg-[#E8500A] text-white" : "bg-gray-100 text-gray-500"}`}>
                      <i className={`text-sm ${openId === faq.id ? "ri-subtract-line" : "ri-add-line"}`} />
                    </span>
                  </button>
                </dt>
                {openId === faq.id && <dd className="px-6 pb-5"><p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p></dd>}
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* 10. Final CTA */}
      <FinalCTASection />
    </main>
  );
}
